import { createStyles } from "antd-style";

export const useModalSubscriptionCancelStyles = createStyles(
  ({ css }: any) => ({
    drawer: css`
      position: relative;
    `,
    loader: css`
      position: absolute;
      inset: 0;
      margin: auto;
    `,
  }),
);
